import React from "react"

import "twin.macro"
import Container from "@components/structure/Container"
import Section from "@components/structure/Section"

const References = ({ references, ...rest }) => {
  return (
    <>
      {references && (
        <Section tw="pt-4 pb-10 lg:(py-12)" {...rest}>
          <Container>
            <div tw="break-words font-karla text-purple text-[10px] leading-[1.1] lg:text-sm">
              <span tw="font-extrabold">{`Reference${references?.length > 1 ? "s" : ""
                }: `}</span>

              {references?.map((reference, i) => {
                return (
                  <span key={`reference-${reference}-${i}`}>
                    <span tw="font-extrabold">{i + 1}.</span>&nbsp;
                    {reference}{" "}
                  </span>
                )
              })}
            </div>
          </Container>
        </Section>
      )}
    </>
  )
}

export default References
